import { render, staticRenderFns } from "./createTemplatePage.vue?vue&type=template&id=43a24402&scoped=true"
import script from "./createTemplatePage.vue?vue&type=script&lang=js"
export * from "./createTemplatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a24402",
  null
  
)

export default component.exports